import { ErrorState } from './ErrorState';
import { LeftColumn } from './LeftColumn';
import { LoadingState } from './LoadingState';
import { RightColumn } from './RightColumn';
import { useDraftPreview } from '../DraftPreviewProvider';
import { Content } from './styled';
export function Root() {
    const { loading, error } = useDraftPreview();
    if (loading) {
        return <LoadingState />;
    }
    if (error) {
        return <ErrorState />;
    }
    return (<Content>
      <LeftColumn />
      <RightColumn />
    </Content>);
}
